export default {

    methods: {

        cleanup(text) {
            var replaceWith = text;

            // Change all spaces after starting quotes and before closing quotes to be non-breaking
            // TBD - you can use this instead of non-breaking space if you like: // String.fromCharCode(160);

            var nonBreakingOpen = "«  ";
            var normalSpaceOpen = "« ";
            if (replaceWith.includes(normalSpaceOpen)) {
                replaceWith = replaceWith.replaceAll(normalSpaceOpen, nonBreakingOpen);
            }

            var nonBreakingClose = "  »";
            var normalSpaceClose = " »";
            if (replaceWith.includes(normalSpaceClose)) {
                replaceWith = replaceWith.replaceAll(normalSpaceClose, nonBreakingClose);
            }

            var nonBreakingColon = "  :";
            var normalSpaceColon = " :";
            if (replaceWith.includes(normalSpaceColon)) {
                replaceWith = replaceWith.replaceAll(normalSpaceColon, nonBreakingColon);
            }

            return replaceWith;
        },
        LG(tag) {

            if (tag != null) {

                if (tag.includes("_S1_")) {
                    return this.cleanup(this.LG1(tag));
                }
                if (tag.includes("_S2_")) {
                    return this.cleanup(this.LG2(tag));
                }
                if (tag.includes("_S3_")) {
                    return this.cleanup(this.LG3(tag));
                }
                if (tag.includes("_S4_")) {
                    return this.cleanup(this.LG4(tag));
                }
                if (tag.includes("_S5_")) {
                    return this.cleanup(this.LG5(tag));
                }
                if (tag.includes("_S6_")) {
                    return this.cleanup(this.LG6(tag));
                }
                if (tag.includes("_S7_")) {
                    return this.cleanup(this.LG7(tag));
                }
                if (tag.includes("_S8_")) {
                    return this.cleanup(this.LG8(tag));
                }
                if (tag.includes("_S9_")) {
                    return this.cleanup(this.LG9(tag));
                }
                if (tag.includes("_S10_")) {
                    return this.cleanup(this.LG10(tag));
                }
                if (tag.includes("_S11_")) {
                    return this.cleanup(this.LG11(tag));
                }
                if (tag.includes("_S12_")) {
                    return this.cleanup(this.LG12(tag));
                }
            }


            const languageTable = {
                // Global language.csv
                G_underconstruction: "À venir",
                G_startButtonLabel: "COMMENCER",
                G_closeButtonLabel: "X",
                G_continueLabel: "CONTINUER",
                G_submitButtonLabel: "SOUMETTRE",
                G_transcriptionLabel: "Transcription de la vidéo",
                G_DeleteButton: "SUPPRIMER",
                G_CancelLabel: "ANNULER",
                G_YesButtonLabel: "Oui",
                G_NoButtonLabel: "Non",
                HP_titleIntroduction: "Introduction",
                HP_deleteProfileText: "Réinitialiser le profil",
                HP_homeButtonAlt: "Page d'accueil",
                HP_homeButtonLabel: "Accueil",
                HP_mapButtonLabel: "Carte",
                HP_blocnoteButtonLabel: "Bloc-notes",
                HP_planDeSiteButtonLabel: "Table des matières",
                HP_altLogo: "FORMATION EN PETITE ENFANCE Faire le point pour aller plus loin",
                HP_paragraph1: "Ce jeu interactif a été développé pour te permettre d’explorer différentes situations que tu peux rencontrer dans ton milieu de travail. Naviguer à travers ces situations te permettra d’approfondir tes connaissances du domaine de la petite enfance et t’outillera davantage à répondre le mieux possible aux besoins des enfants et des familles avec qui tu travailles.",
                HP_paragraph2: "Visionne la vidéo afin d’en apprendre davantage sur le fonctionnement du jeu.",
                HP_paragraph3: "Sélectionne le bouton CONTINUER.",
                HP_paragraph4: "Sélectionne le bouton COMMENCER pour démarrer le jeu.",
                HP_buttonObjectives: "Objectifs",
                HP_buttonResources: "Ressources",
                HP_altCanadaLogo: "Financé par le gouvernement du Canada par le biais du Programme de partenariats pour le développement social - volet Enfants et familles",

                SA_altAreaSection1: "Section 1 : Centre ON y va",
                SA_altAreaSection2: "Section 2 : Service éducatif",
                SA_altAreaSection3: "Section 3 : Service parascolaire",
                SA_altAreaSection4: "Section 4 : Milieu familial",

                SA_nameAreaSection1: "Centre ON y va",
                SA_nameAreaSection2: "Service éducatif",
                SA_nameAreaSection3: "Service parascolaire",
                SA_nameAreaSection4: "Milieu familial",

                SA_heading1: "Consignes de départ",
                SA_paragraph1: "Ce jeu t’invite à effectuer une minienquête pour résoudre une situation. Tu dois trouver les indices cachés dans chaque scène et choisir la meilleure intervention pour la mise en situation proposée.",
                SA_paragraph2: "Bonne découverte!",
                SA_paragraph3: "Sélectionne l’environnement de ton choix pour accéder aux mises en situation.",
                SS_labelSituation1: "L’accueil des familles",
                SS_labelSituation2: "L’écoute visible",
                SS_labelSituation3: "Un milieu inclusif et stimulant<br /> pour toutes et tous!",
                SS_labelSituation4: "Ici, je suis chez moi!",
                SS_labelSituation5: "Nature et découverte",
                SS_labelSituation6: "Un environnement riche <br />en expériences d’apprentissage",
                SS_labelSituation7: "Cultiver de saines habitudes de vie",
                SS_labelSituation8: "On joue dehors!",
                SS_labelSituation9: "L’expression sous toutes ses formes",
                SS_labelSituation10: "À la découverte de ma communauté...",
                SS_labelSituation11: "Prête ou prêt pour l'école, prête ou prêt pour la vie!",
                SS_labelSituation12: "Explorons le jeu aventureux!",
                SS_altSituation1: "Mise en situation 1",
                SS_altSituation2: "Mise en situation 2",
                SS_altSituation3: "Mise en situation 3",
                SS_altSituation4: "Mise en situation 4",
                SS_altSituation5: "Mise en situation 5",
                SS_altSituation6: "Mise en situation 6",
                SS_altSituation7: "Mise en situation 7",
                SS_altSituation8: "Mise en situation 8",
                SS_altSituation9: "Mise en situation 9",
                SS_altSituation10: "Mise en situation 10",
                SS_altSituation11: "Mise en situation 11",
                SS_altSituation12: "Mise en situation 12",
                SS_heading1: "Les mises en situation",
                SS_paragraph1: "Trouve les indices cachés dans chaque scène. En sélectionnant les indices, tu obtiendras plus d’information à leur sujet. Ceux-ci t’aideront à choisir la meilleure intervention pour la mise en situation en cours.",
                SS_paragraph2: "<strong>À NOTER!</strong> Certains indices ne sont pas pertinents dans le cadre de la mise en situation.",
                SS_paragraph3: "Sélectionne la mise en situation de ton choix.",
                SS_paragraph3B: "Sélectionne la mise en situation.",
                CR_nextButtonLabel: "SUITE >",
                CR_prevButtonLabel: "< PRÉCÉDENT",
                CR_tabLabel: "Indice ",
                CR_recapHeading: "Récapitulatif",
                CR_pedagogyHeading: "Note pédagogique",
                CR_resumeHeading: "Résumé des indices",
                IV_headingIntervention: "Intervention",
                IV_headingRetroaction: "Rétroaction",
                CO_title: "Conclusion",
                CO_mainHeading: "Cette mise en situation touche les <a target='_blank' href='http://www.edu.gov.on.ca/gardedenfants/oelf/principles/'>principes</a> de <a target='_blank' href='http://www.edu.gov.on.ca/gardedenfants/ExcerptsFromELECTFr.pdf'>l’apprentissage des jeunes enfants à la portée de tous dès aujourd’hui (AJEPTA)</a> énumérés ci-dessous.",
                CO_nextButtonLabel: "SUITE",
                CO_quizButtonLabel: "JEU-QUESTIONNAIRE",
                CO_altStarImage: "une étoile",
                CO_downloadPdfText: "TÉLÉCHARGER LES MESSAGES CLÉS",
                CO_finalizeMessage: "",
                QI_title: "QUESTIONNAIRE",
                QI_continueButtonLabel: "CONTINUER",
                QI_skipButtonLabel: "Aller au récapitulatif",
                QR_heading1: "",
                QR_paragraph1: "Bravo! Tu as réussi la mise en situation.<br />Tu en sais maintenant plus sur les fondements ci-contre.",
                QR_startButtonLabel: "CONTINUER",
                QR_category1: "Bien-être",
                QR_category2: "Engagement",
                QR_category3: "Expression",
                QR_category4: "Appartenance",
                QR_surveyText: "Donne-nous ton avis sur ce jeu sérieux.",
                QR_surveyShortText: "SONDAGE",
                LO_loginTextStart: "Afin de sauvegarder ta progression, ",
                LO_loginTextLink: "crée-toi un compte",
                LO_loginTextEnd: "GRATUITEMENT!",
                LO_emailText: "Courriel",
                LO_passwordText: "Mot de passe",
                LO_emailLabel: "Courriel",
                LO_emailPlaceholder: "Tape ton courriel",
                LO_passwordLabel: "Mot de passe",
                LO_passwordPlaceholder: "Tape ton mot de passe",
                LO_loginButtonText: "Se connecter",
                LO_logoutButtonText: "Se déconnecter",
                LO_connectText: "Connexion",
                LO_sendEmailText: "Envoyer un e-mail",
                LO_cancelLabel: "Annuler",
                LO_forgotPasswordText: "Mot de passe oublié",
                LO_errorMessage: "Il semble y avoir un problème",
                LO_errorLabel: "Erreur d'identification",
                LO_genericError: "Échec de connexion",
                LO_NewUIButton: "Gabarit nouveau",
                LO_OldUIButton: "Gabarit originale",
                RP_titleLabel: "Créer un compte",
                RP_titleSuccessLabel: "Compte créé avec succès",
                RP_changePassword: "Changer le mot de passe",
                RP_changePasswordSuccess: "Le mot de passe est changer avec succès",
                RP_changePasswordFail: "La réinitialisation du mot de passe a échoué",
                RP_resetLabel: "Réinitialiser",
                RP_firstNameLabel: "Prénom",
                RP_firstNamePlaceholder: "Tape ton prénom ",
                RP_firstNameMaxLength: "La longueur maximale du prénom est: ",
                RP_firstNameRequired: "Prénom obligatoire",
                RP_lastNameLabel: "Nom de famille",
                RP_lastNamePlaceholder: "Tape ton nom de famille",
                RP_lastNameMaxLength: "La longueur maximale du nom de famille est: ",
                RP_lastNameRequired: "Nom de famille requis",
                RP_emailLabel: "Courriel",
                RP_emailPlaceholder: "Inscris ton courriel",
                RP_emailMaxLength: "La longueur maximale du courriel est: ",
                RP_emailRequired: "Courriel requis",
                RP_validEmailRequired: "Courriel valide requis",
                RP_passwordLabel: "Mot de passe",
                RP_newPasswordLabel: "Nouveau mot de passe",
                RP_confirmPasswordLabel: "Confirme ton mot de passe",
                RP_passwordPlaceholder: "Choisis ton mot de passe",
                RP_passwordMaxLength: "La longueur maximale du mot de passe est: ",
                RP_passwordRequired: "Mot de passe requis",
                RP_passwordsDontMatch: "Les mots de passe ne correspondent pas",
                RP_registerLabel: "S'inscrire",
                RP_cancelLabel: "Annuler",
                RP_continueLabel: "Continuer",
                RP_errorMessage: "Veuillez corriger les erreurs suivantes:",
                RP_successMessage: "Bienvenue, ",
                RP_errorLabel: "Erreur d'enregistrement",
                RP_genericError: "Échec de connexion",
                SV_paragraph1: "Clique sur le bouton COMMENCER pour démarrer le jeu.",
                SV_watchVideo: "Visionne la vidéo avant de continuer.",
                PP_irrelevantText: "Cet indice n'est pas pertinent à la mise en situation. Continue à chercher.",
                PP_relevantText: "Cet indice est pertinent à la mise en situation. Essaie de nouveau.",
                PP_KeepClueMessage: "Souhaites-tu garder cet indice?",
                PP_GameComplete1: "Tu as réussi à trouvé tous les indices de la mise en situation",
                PP_GameComplete2: ". Clique sur le bouton",
                PP_GameComplete3: "afin de poursuivre au Résumé des indices de cette mise en situation.",
                V2_score: "Ton parcours",
                ZZ_PasswordRquired: "Mot de passe requis",
                ZZ_EmailTaken: "E-mail X est déjà pris",
                ZZ_UserNotFound: "Utilisateur non trouvé",
                ZZ_UserNotDeleted: "L'utilisateur n'a pas pu être supprimé.",
                ZZ_InvalidEmailPassword: "E-mail ou mot de passe incorrect",
                ZZ_InvalidEmail: "E-mail incorrect",
                ZZ_LinkExpires: "échec de la réinitialisation du mot de passe - lien expiré",
                ZZ_ForgotPasswordEmailSubject: "Mot de passe oubliée : Petite Enfance",
                ZZ_ForgotPasswordEmailLine1: "Bonjour X, suivez ce lien pour réinitialiser votre mot de passe pour Petite Enfance : ",
                ZZ_ConfirmationEmailSubject: "Confirmation d'inscription Petite Enfance",
                ZZ_ConfirmationEmailLine1: "Bonjour X, merci d'avoir créé un compte chez Petite Enfance : ",

            };

            if (languageTable[tag] == null) {
                return "*MISSING* TAG=" + tag;
            }


            return this.cleanup(languageTable[tag]);
        },
    }
}
